module.exports = __webpack_public_path__ + "static/media/master_card.9134763b.png";